import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/Layout.js";
import { useLocation } from "react-router-dom";
import { apiFetch } from "../../api.js";
import Select from "react-select";

const BookingCancelDetailsDesign = () => {
  const navigate = useNavigate();
  const [ipAddress, setIpAddress] = useState("");
  const [userId, setUserId] = useState("");
  const [serverIp] = useState(window.location.hostname);
  const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
  const locationState = useLocation();
  const editUnqId = locationState.state?.unqid || null;
  const [Customername, setCustomername] = useState("");
  const isCustomerSelected = !!Customername;
  const [Date, setDate] = useState("");
  const [Model, setModel] = useState("");
  const [Variant, setVariant] = useState("");
  const [Color, setColor] = useState("");
  const [Saleconsultant, setSaleconsultant] = useState("");
  const [modelOptions, setModelOptions] = useState([]);
  const [variantOptions, setVariantOptions] = useState([]);
  const [colorOptions, setColorOptions] = useState([]);
  const [staffOptions, setStaffOptions] = useState([]);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [gridRows, setGridRows] = useState([]);

  const customStyles = {
    control: (base) => ({ ...base, minHeight: "40px" }),
  };
  useEffect(() => {
    apiFetch("/api/get-ip")
      .then((res) => res.json())
      .then((data) => setIpAddress(data.ip))
      .catch(() => setIpAddress("0.0.0.0"));
  }, []);
  const handleExit = () => navigate("/VehicleAllocationGrid");

  return (
    <Layout>
      <div className="page-container">
        <div className="container">
          <div className="header">Booking Cancel</div>

          {/* FORM ROW 1 */}
          <div className="form-row">
            <div className="form-column">
              <label>Customer Name</label>
              <Select
                placeholder="Select Customer"
                options={customerOptions}
                value={
                  customerOptions.find((o) => o.value === Customername) || null
                }
                onChange={(e) => {
                  const selectedId = e?.value;
                  setCustomername(selectedId);
                }}
              />
            </div>
            <div className="form-column">
              <label>cancel Date</label>
              <input
                type="date"
                value={Date}
                disabled={true}
                onChange={(e) => setDate(e.target.value)}
              />
            </div>
          </div>

          {/* FORM ROW 2 */}
          <div className="form-row">
            <div className="form-column">
              <label>Model</label>
              <Select
                options={modelOptions}
                isDisabled={true}
                placeholder="Select Model"
                classNamePrefix="rs"
                styles={customStyles}
                value={Model}
                onChange={setModel}
              />
            </div>
            <div className="form-column">
              <label>Variant</label>
              <Select
                options={variantOptions}
                isDisabled={true}
                placeholder="Select Variant"
                classNamePrefix="rs"
                styles={customStyles}
                value={Variant}
                onChange={setVariant}
              />
            </div>
            <div className="form-column">
              <label>Color</label>
              <Select
                options={colorOptions}
                isDisabled={true}
                placeholder="Select Color"
                classNamePrefix="rs"
                styles={customStyles}
                value={Color}
                onChange={setColor}
              />
            </div>
          </div>

          {/* FORM ROW 3 */}
          <div className="form-row">
            <div className="form-column">
              <label>Sale Consultant</label>
              <Select
                options={staffOptions}
                isDisabled={true}
                value={Saleconsultant}
                placeholder="Select Sale Consultant"
                classNamePrefix="rs"
                styles={customStyles}
                onChange={(e) => setSaleconsultant(e)}
              />
            </div>
            <div className="form-column">
              <label>Cancellation Reason </label>
              <Select
                placeholder="Select Customer"
                options={customerOptions}
                value={
                  customerOptions.find((o) => o.value === Customername) || null
                }
                onChange={(e) => {
                  const selectedId = e?.value;
                  setCustomername(selectedId);
                }}
              />
            </div>
          </div>

          {/* GRID */}
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>R No</th>
                  <th>Date</th>
                  <th>Cheque No</th>
                  <th>Cash</th>
                  <th> Cheque Amt</th>
                  <th>UPI</th>
                  <th>Rtgs/Neft/Imps</th>
                  <th>Wallet</th>
                  <th>Card</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {gridRows.map((r, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{r.model}</td>
                    <td>{r.variant}</td>
                    <td>{r.color}</td>
                    <td>{r.year}</td>
                    <td>{r.fsc}</td>
                    <td>{r.vin}</td>
                    <td>{r.pdi}</td>
                    <td>{r.location}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* BUTTONS */}
          <div className="va-btn-container">
            <button className="va-btn-save">Save</button>
            <button className="va-btn-exit">Exit</button>
          </div>
        </div>
      </div>

      {/* 🔥 YOUR FULL STYLE SECTION STAYS EXACTLY AS IT IS BELOW */}

      {/* ----------------------------------------------------
            CSS EXACTLY LIKE INSURANCE MASTER / RATE MASTER
      ---------------------------------------------------- */}
      <style>
        {`
/* ================= PAGE ================= */

.page-container {
  width: 100%;
  min-height: 100vh;
  background: #f4f6f8;
  display: flex;
  justify-content: center;
  padding: 10px;
  box-sizing: border-box;
}

.container {
  width: 100%;
  max-width: 1400px;
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 4px 8px rgba(0,0,0,.1);
}

/* ================= HEADERS ================= */

.header,
.header1 {
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  padding: 15px;
  background: #8B1E3F;
  color: #fff;
  border-radius: 6px;
  margin-bottom: 20px;
}

/* ================= FORM GRID ================= */

.form-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}



.form-column {
  display: flex;
  flex-direction: column;
}

label {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
}

/* ================= INPUTS ================= */

input,
select {
  height: 40px !important;
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
  box-sizing: border-box;
  background: #fff;
}

input[type="date"] {
  padding-right: 35px;
}

/* ================= react-select FIX ================= */

.rs__control {
  min-height: 40px !important;
  height: 40px !important;
  border-radius: 5px !important;
}

.rs__value-container {
  height: 40px !important;
  padding: 0 10px !important;
  display: flex;
  align-items: center;
}

.rs__indicator {
  padding: 6px !important;
}

.rs__menu-portal {
  z-index: 9999 !important;
}

/* ================= RADIO ================= */

.company-auth {
  max-width: 220px;
}

.radio-group {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 8px;
}

.radio-group label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
}

.radio-group input {
  width: 16px;
  height: 16px;
}

/* ================= TABLE ================= */

.table-container {
  width: 100%;
  overflow-x: auto;
  margin-top: 20px;
  border: 1px solid #ddd;
  border-radius: 6px;
}

table {
  width: 100%;
  min-width: 800px;
  border-collapse: collapse;
  font-size: 13px;
}

th,
td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: center;
}

thead tr {
  background: #f8bcbc;
}

.grid-input {
  width: 100%;
  height: 32px;
  border: 1px solid #ccc;
  border-radius: 4px;
  text-align: center;
}

/* ================= BUTTONS ================= */

.va-btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 30px;
  padding: 0 8px;
}

.va-btn-save,
.va-btn-exit {
  min-width: 120px;
  min-height: 44px;
  padding: 10px 24px;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  transition: background 0.2s;
  white-space: nowrap;
  box-sizing: border-box;
}

.va-btn-save {
  background: #4caf50;
  color: #fff;
}
.va-btn-save:hover { background: #43a047; }

.va-btn-exit {
  background: #ab2025;
  color: #fff;
}
.va-btn-exit:hover { background: #b02a37; }

.button-container {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 20px;
  flex-wrap: wrap;
}

.button-container button {
  min-width: 120px;
  min-height: 44px;
  padding: 12px 18px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  box-sizing: border-box;
}

.btn-save {
  background: #4caf50;
  color: #fff;
  border: none;
}

.btn-exit {
  background: #a20d0d;
  color: #fff;
  border: none;
}

.btn-edit {
  background: #2e20ab;
  color: #fff;
  border: none;
  padding: 6px 14px;
  border-radius: 4px;
  font-size: 12px;
}

/* ================= RESPONSIVE ================= */

/* Tablet */
@media (max-width: 1024px) {
  .form-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Mobile */
@media (max-width: 600px) {
  .form-row {
    grid-template-columns: 1fr;
  }

  .va-btn-container {
    flex-direction: column;
    align-items: stretch;
    padding: 0 16px;
  }

  .va-btn-save,
  .va-btn-exit {
    width: 100%;
    text-align: center;
    font-size: 15px;
    padding: 12px 16px;
  }

  .button-container button {
    flex: 1;
    width: 100%;
  }
}

/* Extra small */
@media (max-width: 400px) {
  .va-btn-save,
  .va-btn-exit {
    font-size: 14px;
    padding: 11px 12px;
  }
}

`}
      </style>
    </Layout>
  );
};

export default BookingCancelDetailsDesign;
